import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';
import axios from 'axios';


axios.defaults.baseURL = process.env.REACT_APP_BE_URL
window.React1 = require('react');
ReactDOM.render(
    <App />,
  document.getElementById('root')
);